<template>
  <div class="orderconfig-container">
    <div class="bg" />
    <div class="orderconfig-wrap">
      <div class="orderconfig-wrap-i">
        <div class="inner">
          <!-- <img class="img-dog" src="./images/dog.png" v-if="showDog" /> -->
          <div class="header">
            <span>{{data?.name}}</span>
            <el-icon :size="16" @click="$emit('cancel')"><Close /></el-icon>
          </div>
          <el-form :model="form" label-width="auto" label-position="top" style="padding-bottom: 32px;">
            <el-form-item label="选择文件" :required="data?.needFile == 1">
              <el-upload
                v-model:file-list="fileList"
                :action="Request.uploadURL"
                :limit="1"
                :on-error="uploadErrorHandle"
              >
                <el-button plain type="primary"><el-icon :size="20"><Upload /></el-icon><span style="margin-left: 4px;">上传文件</span></el-button>
              </el-upload>
            </el-form-item>

            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item class="carrier-account-form-item">
                  <div class="carrier-account-label">
                    <span><i>*</i>船司账号</span>
                    <div class="carrier-account-group-switch">
                      <span>展示分组</span>
                      <el-switch v-model="showAccountGroup" size="small" />
                    </div>
                  </div>
                  <el-select class="carrier-account-select" v-model="form.accountIds" multiple collapse-tags filterable popper-class="carrier-account-dropdown">
                    <template v-if="showAccountGroup">
                      <div class="carrier-account-group" v-for="group in groupedCarrierAccounts" :key="group.key">
                        <div class="el-select-group__title carrier-account-group-title" @click.stop="toggleAccountGroup(group.key)">
                          <el-icon><ArrowRight v-if="isAccountGroupCollapsed(group.key)" /><ArrowDown v-else /></el-icon>
                          <span>{{ `${group.name}（${group.accounts.length}）` }}</span>
                        </div>
                        <div class="carrier-account-group-options" v-show="!isAccountGroupCollapsed(group.key)">
                          <el-option :value="item.id" v-for="item in group.accounts" :key="item.id" :label="item.username">
                        <template v-if="showAccountInfo">
                          <div v-if="item.status===1" class="option-span">
                            <span class="username">{{ item.username }}</span>
                            <div class="option-span-text">
                              <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="消耗次数"
                                placement="top-start"
                              >
                                <el-icon><InfoFilled /></el-icon>
                              </el-tooltip>
                              <span>{{ item.useCount }}</span>
                            </div>
                          </div>
                          <div v-if="item.status===2" class="option-span">
                            <span class="username">{{ item.username }}</span>
                            <span class="option-span-text danger-span">已达上限</span>
                          </div>
                        </template>
                          </el-option>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <el-option :value="item.id" v-for="item in carrierAccounts" :key="item.id" :label="item.username">
                      <template v-if="showAccountInfo">
                        <div v-if="item.status===1" class="option-span">
                          <span class="username">{{ item.username }}</span>
                          <div class="option-span-text">
                            <el-tooltip class="box-item" effect="dark" content="消耗次数" placement="top-start">
                              <el-icon><InfoFilled /></el-icon>
                            </el-tooltip>
                            <span>{{ item.useCount }}</span>
                          </div>
                        </div>
                        <div v-if="item.status===2" class="option-span">
                          <span class="username">{{ item.username }}</span>
                          <span class="option-span-text danger-span">已达上限</span>
                        </div>
                      </template>
                      </el-option>
                    </template>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="参数模版" required>
                  <el-select v-model="form.paramsTemplateId">
                    <el-option :value="item?.id" v-for="(item, index) in paramTemplates" :key="index" :label="item?.displayName" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="执行方式" required>
              <el-radio-group v-model="form.executeType" :disabled="mode == 'edit'">
                <el-radio :value="1" v-if="normalExecuteFlag">常规执行</el-radio>
                <el-radio :value="2" v-if="plannedExecuteFlag">计划执行</el-radio>
              </el-radio-group>
              <img src="@/assets/images/pluslimit.svg" v-if="plannedExecuteFlag" style="margin-left: 2px; width: 50px; height: 14px; display: block;" />
            </el-form-item>
            <div class="form-method-wrap" v-if="form?.executeType == 1">
              <el-form-item label="执行时间" required>
                <el-date-picker
                  v-model="form.executeTime" type="datetime" value-format="x" placeholder="请选择"
                  :disabled-date="
                    (time) => {
                      return time.getTime() < Date.now() - 3600 * 1000 * 24;
                    }
                  "
                />
              </el-form-item>
            </div>
            <div class="form-method-wrap" style="width: 523px; padding-bottom: 36px;padding-right: 36px;" v-if="form?.executeType == 2">
              <el-row :gutter="8">
                <el-col :span="10">
                  <el-form-item label="执行周期" required>
                    <el-date-picker
                      v-model="form.plannedExecuteTime" type="daterange" value-format="x" range-separator="" start-placeholder="开始日期" end-placeholder="结束日期"
                      @change="handleDateChange"
                      :disabled-date="
                        (time) => {
                          return time.getTime() < Date.now() - 3600 * 1000 * 24;
                        }
                      "
                    >
                      <template v-slot:range-separator>
                        <img src="./images/trial-right.svg" style="width: 16px; height: 16px;" />
                      </template>
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="" style="margin-top: 30px;">
                    <el-select v-model="form.executeWeekday" :multiple="true" placeholder="请选择" collapse-tags>
                      <el-option v-for="(itm, idx) in executeWeekdayOptoins" :disabled="form.executeWeekday?.length > 0 && ((form.executeWeekday?.includes(0) && itm.value != 0) || (!form.executeWeekday?.includes(0) && itm.value == 0))" :label="itm.label" :value="itm.value" :key="idx" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="每日执行时间区间" required>
                <div class="day-executes-range-wrap" :style="{marginBottom:  hourSelectResult?.length > 0 ? '' : '16px!important' }">
                  <div class="item" v-for="(item, index) in hourList" :key="index">
                    <em :class="{ active: item?.status == 3, preactive: item?.status == 2 }" @click="dayExecuteTimeHandle(item, index)" />
                    <i>{{ item.h }}</i>
                    <i class="last" v-if="item.h == 23">{{ item.h + 1}}</i>
                  </div>
                </div>
                <div class="day-executes-results" v-if="hourSelectResult?.length > 0">
                  <div class="item" v-for="(item, index) in hourSelectResult" :key="index">
                    <span>{{beautiH(item[0]?.h)}}~{{beautiH((item[1]?.h || item[0]?.h)+1)}}</span>
                    <img class="close-executes" src="./images/close.svg" @click="delDayExecuteTimeHandle(item[0]?.h, item[1]?.h)" />
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="执行频率" required>
                <div class="block-input-wrap">
                  <span>每</span>
                  <el-input-number :min="1" :max="60" :precision="0" v-model="form.frequency" style="width: 89px;" />
                  <span>分钟执行1次</span>
                </div>
              </el-form-item>
              <el-form-item label="备注">
                <el-input v-model="form.remark" type="textarea" placeholder="请输入相关备注信息" />
              </el-form-item>
            </div>

            <div style="margin-top: 24px; display: flex; justify-content: flex-end;">
              <el-button @click="$emit('cancel')">取消</el-button>
              <el-popconfirm title="您还未配置通知方式，任务执行结果将无法通知结果，请确认是否继续执行？" width="282px" v-if="showNotifySettingDialog">
                <template #reference>
                  <el-button type="primary" :disabled="submitBtnFlag" :loading="submitLoading">确认</el-button>
                </template>
                <template #actions="{ confirm, cancel }">
                  <el-button size="small" @click="cancel">取消任务</el-button>
                  <el-button type="primary" size="small" @click="submitOrder()" :loading="submitLoading">继续执行</el-button>
                </template>
              </el-popconfirm>
              <template v-else>
                <el-button type="primary" @click="submitOrder" :disabled="submitBtnFlag" :loading="submitLoading">确认</el-button>
              </template>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import {onMounted, ref, watch, computed} from 'vue'
  import { useRouter, useRoute } from 'vue-router';
  import { ArrowDown, ArrowRight, Close, Upload, InfoFilled } from '@element-plus/icons-vue'
  import { ElMessage, ElMessageBox, ElNotification } from 'element-plus'
  import * as Request from '@/assets/request';
  import EventBus from '@/assets/eventbus';
  import * as Utils from '@/assets/utils';
  const route = useRoute();

  const emits = defineEmits([ 'cancel', 'refresh' ])

  const props = defineProps({
    showDog: {
      type: Boolean,
      default: true
    },
    data: {
      type: Object,
      default: null
    },
    executeType: {
      type: Number,
      default: 1
    },
    mode: {
      type: String,
      default: 'add'  // edit
    }
  })

  const showAccountInfo = computed(() => {
    return ['query_price_qq', 'query_price_qq_qqs'].includes(props.data.appCode)
  })

  // 是否有联系方式
  const showNotifySettingDialog = ref(false);
  const notifySettingDialog = async () => {
    const result = await Request.post({
      url: '/22001/facade/dispatch/notifySettingDialog'
    });
    if(result?.code != 200) return;

    showNotifySettingDialog.value = result.data;
  }
  onMounted(() => {
    notifySettingDialog();
  })

  const form = ref({})
  const initForm = () => {
    form.value = {
      executeWeekday: [0],
      ...props.data,
      executeType: props.executeType
    }
    if(!form.value?.executeWeekday || form.value?.executeWeekday?.length == 0) {
      form.value.executeWeekday = [0];
    }

    // 每日执行时间区间
    if(props.data?.dayExecuteTime?.length > 0) {
      for(let i = 0 , len = props.data?.dayExecuteTime.length; i < len; i++){
        const dayExecuteTimeItem = props.data?.dayExecuteTime[i];
        hourList.value.map(hourItem => {
          if(dayExecuteTimeItem[0] == dayExecuteTimeItem[1]){
            if(hourItem.h == dayExecuteTimeItem[0]){
              hourItem.status = 3;
            }
          }else {
            if(hourItem.h >= dayExecuteTimeItem[0] && hourItem.h <= dayExecuteTimeItem[1]) {
              hourItem.status = 3;
            }
          }
          return hourItem;
        })
      }
    }

    // 上传图片
    let fileItemObj = null
    if(props.data?.fileId) {
      fileItemObj = {
        response: {
          data: {
            fileId: props.data?.fileId
          }
        }
      }
    }
    if(props.data?.fileUrl) {
      fileItemObj.name = (() => {
        if(props.data?.originalFileName) return props.data?.originalFileName;
        if(!props.data?.fileUrl) return '';

        const fileArr = props.data?.fileUrl.split('/');
        let targetPath = ''
        fileArr.map(f => {
          if(f && f.indexOf('.svg') > -1) {
            targetPath = f.split('?')[0];
          }
        })
        return targetPath;
      })()
    }
    if(fileItemObj) {
      fileList.value = [fileItemObj]
    }
  }

  const handleDateChange = (value) => {
    if (value && value.length === 2) {
      const [startTimestamp, endTimestamp] = value;

      // 将结束日期的时间戳调整为当天的 23:59:59
      const adjustedEndTimestamp = endTimestamp + (24 * 3600 - 1) * 1000;

      form.value.plannedExecuteTime = [startTimestamp,adjustedEndTimestamp]
    }
  }

  // 参数模版
  const paramTemplates = ref([])
  const getParamTemplates = async () => {
    if(!props?.data?.groupId) return;

    const result = await Request.post({
      url: '/22001/facade/commons/params/template/getTemplateByType',
      data: {
        appGroup: props?.data?.groupId,
        appId: props?.data?.appId || props?.data?.id
      }
    });
    if(result?.code != 200) return;
    paramTemplates.value = result?.data || []
  }
  // 船司账号
  const carrierAccounts = ref([])
  const showAccountGroup = ref(false)
  const collapsedAccountGroups = ref({})
  const groupedCarrierAccounts = computed(() => groupAccounts(carrierAccounts.value))
  const getAccountByCarrier = async () => {
    if(!props?.data?.groupId) return;

    const result = await Request.post({
      url: '/22001/facade/commons/carrier/account/getByCarrier',
      data: props?.data?.groupId
    });
    if(result?.code != 200) return;
    carrierAccounts.value = result?.data || []
  }
  const groupAccounts = accounts => {
    const groupMap = new Map();
    accounts.forEach(account => {
      const grouped = Boolean(account?.groupId);
      const key = grouped ? `group-${account.groupId}` : 'ungrouped';
      if(!groupMap.has(key)) {
        groupMap.set(key, {
          key,
          name: grouped ? account.groupName || '未命名分组' : '未分类',
          sort: grouped ? account.groupSort ?? Number.MAX_SAFE_INTEGER : Number.MAX_SAFE_INTEGER,
          accounts: []
        });
      }
      groupMap.get(key).accounts.push(account);
    });
    return Array.from(groupMap.values()).sort((a, b) => a.sort - b.sort || a.name.localeCompare(b.name));
  }
  const isAccountGroupCollapsed = groupKey => Boolean(collapsedAccountGroups.value[groupKey])
  const toggleAccountGroup = groupKey => {
    collapsedAccountGroups.value[groupKey] = !collapsedAccountGroups.value[groupKey]
  }
  const init = async () => {
    await getAccountByCarrier();
    await getParamTemplates();
    initForm();
  }
  onMounted(() => {
    init();
  })
  watch(() => props?.data, () => {
    init();
  }, { deep: true });

  /**
   * 上传文件
   */
  const fileList = ref([]);
  const uploadErrorHandle = (err, file, fileList) => {
    const error = JSON.parse(err.message);
    if(error?.msg) {
      ElMessage.error(error?.msg)
    }
  }

  /**
   * 常规执行 / 计划执行开关
   */
  const normalExecuteFlag = ref(false);
  const plannedExecuteFlag = ref(false);
  const initExecuteFlag = async () => {
    normalExecuteFlag.value = await Utils.pluslimitChecker('hand_normal_execute');
    plannedExecuteFlag.value = await Utils.pluslimitChecker('hand_planned_execute');
  }
  onMounted(() => {
    initExecuteFlag()
  })
  watch(() => route.name, () => {
    initExecuteFlag();
  }, { deep: true });

  /**
   * 每日执行时间选择
   * // status: 1 - 待选择；2 - 点一次（点两次才能选中）；3 - 选中
   */
  const beautiH = (h) => {
    if(h != 0 && !h) return '';

    return `${h < 10 ? '0' + h : h}:00`;
  }
  // 每日小时
  const hourList = ref([
    { h: 0, status: 1 },
    { h: 1, status: 1 },
    { h: 2, status: 1 },
    { h: 3, status: 1 },
    { h: 4, status: 1 },
    { h: 5, status: 1 },
    { h: 6, status: 1 },
    { h: 7, status: 1 },
    { h: 8, status: 1 },
    { h: 9, status: 1 },
    { h: 10, status: 1 },
    { h: 11, status: 1 },
    { h: 12, status: 1 },
    { h: 13, status: 1 },
    { h: 14, status: 1 },
    { h: 15, status: 1 },
    { h: 16, status: 1 },
    { h: 17, status: 1 },
    { h: 18, status: 1 },
    { h: 19, status: 1 },
    { h: 20, status: 1 },
    { h: 21, status: 1 },
    { h: 22, status: 1 },
    { h: 23, status: 1 },
  ]);
  // 周期频率
  const executeWeekdayOptoins = ref([
    { label: '每日都执行', value: 0 },
    { label: '每周一循环执行', value: 1 },
    { label: '每周二循环执行', value: 2 },
    { label: '每周三循环执行', value: 3 },
    { label: '每周四循环执行', value: 4 },
    { label: '每周五循环执行', value: 5 },
    { label: '每周六循环执行', value: 6 },
    { label: '每周日循环执行', value: 7 },
  ]);

  const dayExecuteTimeHandle = (item, index) => {
    const status2Target = (() => {
      let status2Target = null;
      for(let i = 0, len = hourList.value.length; i < len; i++) {
        if(hourList.value[i].status == 2) {
          status2Target = hourList.value[i]
        }
      }
      return status2Target;
    })();

    // 点击了被选中的，无效
    if(item.status == 3) return;

    // 第一次点击，把当前点击的置为初始选中
    if(!status2Target) {
      hourList.value[index].status = 2;
      return;
    }
    // 第二次点击，计算第一次和第二次点击对象的差，把中间的全选中
    if(status2Target.h == item.h) {
      hourList.value[index].status = 3;
    }else{
      for(let i = 0, len = hourList.value.length; i < len; i++) {
        const _item = hourList.value[i];
        if(status2Target.h > item.h) {
          if(item.h <= _item.h && _item.h <= status2Target.h) {
            hourList.value[i].status = 3;
          }
        }
        if(status2Target.h < item.h) {
          if(status2Target.h <= _item.h && _item.h <= item.h) {
            hourList.value[i].status = 3;
          }
        }
      }
    }
    console.log('hourList.value', hourList.value)
  }
  const delDayExecuteTimeHandle = (startH = 0, endH) => {
    console.log('startH, endH', startH, endH)
    if(!endH) {
      for(let i = 0, len = hourList.value.length; i < len; i++) {
        if(hourList.value[i]?.h == startH) {
          hourList.value[i].status = 1;
        }
      }
    }else{
      for(let i = 0, len = hourList.value.length; i < len; i++) {
        const ch = hourList.value[i]?.h;
        console.log('hourList.value[i]?.h', ch)
        if(startH <= ch && ch <= endH) {
          hourList.value[i].status = 1;
        }
      }
    }
  }
  const hourSelectResult = ref([]);
  const getHourSelectResult = () => {
    const map = {}
    let relativeKeys = [];
    for(let i = 0, len = hourList.value.length; i < len; i++) {
      if(relativeKeys[relativeKeys.length - 1] != (i-1)) {
        relativeKeys = [];
      }

      if(hourList.value[i].status == 3) {
        relativeKeys.push(i)
        map[`k-${relativeKeys[0]}`] = map[`k-${relativeKeys[0]}`] || [];
        map[`k-${relativeKeys[0]}`].push(hourList.value[i]);
      }
    }

    hourSelectResult.value = [];
    Object.keys(map).map(key => {
      const list = map[key];

      const _arr = [ list[0] ];
      if(list.length > 1){
        _arr.push(list[list.length - 1]);
      }
      hourSelectResult.value.push(_arr);
    });
  }
  watch(() => hourList.value, () => {
    getHourSelectResult()
  }, { deep: true })

  const submitBtnFlag = ref(false);
  const submitLoading = ref(false);
  const verifySubmitForm = () => {
    const submitObj = {
      ...form.value,
      appGroup: props?.data?.groupId, appId: props?.data?.id, assignType: 1,
      fileId: fileList.value && fileList.value[0] && JSON.parse(JSON.stringify(fileList.value[0]))?.response?.data?.fileId || null,
      dayExecuteTime: []
    }

    if(submitObj?.executeWeekday?.length == 1 && submitObj?.executeWeekday[0] == 0) {
      submitObj.executeWeekday = [];
    }

    if(hourSelectResult.value?.length > 0) {
      hourSelectResult.value.map(item => {
        const arr = [
          item[0]?.h,
          item[1]?.h || item[0]?.h
        ];
        submitObj.dayExecuteTime.push(arr);
      });
    }

    if(props?.data?.needFile == 1 && !submitObj?.fileId) {
      return 1;
    }
    if(!submitObj?.accountIds) {
      return 1;
    }
    if(!submitObj?.paramsTemplateId) {
      return 1;
    }

    if(!submitObj?.executeType) {
      return 1;
    }

    // 常规执行
    if(submitObj?.executeType == 1) {
      if(!submitObj?.executeTime) {
        return 1;
      }
    }

    // 计划执行
    if(submitObj?.executeType == 2) {
      if(!submitObj?.plannedExecuteTime) {
        return 1;
      }
      if(!submitObj?.dayExecuteTime?.length) {
        return 1;
      }
      if(!submitObj?.frequency) {
        return 1;
      }
    }

    return submitObj;
  }
  onMounted(() => {
    submitBtnFlag.value = verifySubmitForm() === 1;
  })
  watch(() => [ form.value, fileList.value, hourSelectResult.value ], () => {
    submitBtnFlag.value = verifySubmitForm() === 1;
  }, { deep: true })

  /**
   * 提交任务
   */
  const submitOrder = async () => {
    submitLoading.value = true;
    ElMessage('任务创建中，请稍后查看结果')
    try {
      const submitObj = verifySubmitForm();
      // // 提交数据的时候要到当天的最后一秒
      // if(submitObj?.plannedExecuteTime?.length == 2) {
      //   submitObj.plannedExecuteTime[1] += Number((24*3600-1)*1000);
      // }
      console.log('submitObj', submitObj)
      // return;
      const result = await Request.post({
        url: props.mode == 'edit' && submitObj?.id ? '/22001/facade/planned/task/update' : '/22001/facade/dispatch/add',
        data: submitObj
      });
      if(result?.code != 200) return;

      EventBus.emit('order_notification', {
        title: props?.mode == 'edit' ? '任务编辑成功' : '任务创建成功',
        traceId: props?.mode == 'edit' ? submitObj?.traceId : result?.data
      })
      emits('cancel');
      emits('refresh');
    } catch (error) {
      ElMessage.error('创建任务失败，请重试')
    } finally {
      submitLoading.value = false;
    }
  }
</script>

<style scoped lang="less">
  @import "./index.less";

  .option-span {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;

    .option-span-text {
      display: flex;
      align-items: center;
      gap: 2px;

      &.danger-span {
        color: red;
        font-size: 14px;
      }
    }
  }
</style>

<style lang="less">
  .carrier-account-dropdown {
    .el-select-group__title {
      background-color: #f4f4f4;
      font-weight: 500;
    }

    .carrier-account-group-title {
      display: flex;
      align-items: center;
      gap: 4px;
      cursor: pointer;
    }
  }
</style>
